import { render, staticRenderFns } from "./QhseAct.vue?vue&type=template&id=beb30d7a&scoped=true&"
import script from "./QhseAct.vue?vue&type=script&lang=js&"
export * from "./QhseAct.vue?vue&type=script&lang=js&"
import style0 from "./QhseAct.vue?vue&type=style&index=0&id=beb30d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb30d7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VDataTable,VDivider,VTextarea})
